import React from 'react';
import {connect} from 'react-redux'
import {Card, CardActions, CardHeader, CardText} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import ContentRemove from 'material-ui/svg-icons/content/remove'
import FloatingActionButton from "material-ui/FloatingActionButton";
import * as colors from 'material-ui/styles/colors';
import $ from "jquery";
import _ from "lodash";
import Loading from './Loading';
import FormText from "./FormText";
import * as commons from "../commons";
import {Field, change, formValueSelector, isDirty} from "redux-form";
import FormSelect from "./FormSelect";
import MenuItem from "material-ui/MenuItem";
import FormAutoComplete2 from "./FormAutoComplete2";
import * as actions from "../actions";
import Dialog from 'material-ui/Dialog'
import FormLabel from "./FormLabel";

const MARKER_INIT = 10
const MARKER_UNIT = 20

class CostMonthCardContents extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            displayCosts: [],
            allCosts: [],
            costs: [],
            page: 0,
            marker: MARKER_INIT
        }
    }

    more() {
        this.setState(Object.assign(this.state, { costs: this.state.costs.concat(this.state.costs) }));
    }

    loadList() {
        this.setState({
            marker: this.state.marker + MARKER_UNIT
        })
    }

    render() {

        const {
            name,
            costs,
            dataSourceConfig,
            dataSourceType,
            dataSource,
            resultDisable,
            status,
            parentIndex,
            dispatch,
            testLoading,
            kind,
            errors
        } = this.props

        return (
            <div>

                {
                    costs && costs.slice(0, this.state.marker).map((row, index) => {
                    // this.state.displayCosts && this.state.displayCosts.map((row, index) => {

                        const error = errors[index] || {}

                        return (
                            <div key={index} className="row" style={{backgroundColor: commons.rowColor(index)}}>
                                <div className="col-1">
                                    <div style={{ display: 'flex', flexDirection: 'column',justifyContent: 'center', alignItems: 'center', height: '100%'}}>
                                        {index + 1}
                                    </div>
                                </div>
                                <div className="col" style={{marginTop: 15, marginBottom: 15}}>
                                    <div className="row">

                                        <div className="col-3">

                                            {dataSourceType === 'select' &&

                                                <Field
                                                    name={`${name}[${parentIndex}].data[${index}].costId`}
                                                    component={FormSelect}
                                                    style={{ width: '100%' }}
                                                    label="項目"
                                                    disabled={status === 3 || kind.startsWith('労務費')}
                                                    meta={{touched: true, error: error.costItem}}
                                                >
                                                    {
                                                        dataSource && dataSource.map((x, index) => {
                                                            return (<MenuItem key={index} value={x.id} primaryText={x.name} />)
                                                        })
                                                    }
                                                </Field>

                                            }

                                            {dataSourceType === 'autoComplete' &&

                                                <Field
                                                    name={`${name}[${parentIndex}].data[${index}].costName`}
                                                    dataSourceConfig={dataSourceConfig}
                                                    dataSource={dataSource}
                                                    component={FormAutoComplete2}
                                                    disabled={status === 3}
                                                    floatingLabelText="項目"
                                                    filter={(searchText, key) => {
                                                        return searchText !== '' && key.indexOf(searchText) !== -1
                                                    }}
                                                    textFieldStyle={{ width: '100%'}}
                                                    style={{ width: '100%' }}
                                                    meta={{touched: true, error: error.costItem}}
                                                />

                                            }
                                        </div>

                                        <div className="col-2">
                                            <Field name={`${name}[${parentIndex}].data[${index}].result`} component={FormText} label="実績"
                                                   style={{ width: '100%' , color: colors.grey400}}
                                                   format={commons.dispMoney}
                                                   normalize={commons.dispMoney}
                                                   disabled={resultDisable ? true : false || status === 3 || (row.importDate ? true : false) || kind.startsWith('労務費')}
                                                   meta={{touched: true, error: error.result}}
                                            />
                                        </div>

                                        {
                                            costs[index].roumuDiff && (
                                                <div className="col-2">
                                                    <FormLabel
                                                        title='時間'
                                                        name='test'
                                                        value={commons.minutesToHour(costs[index].roumuDiff)}
                                                    />
                                                </div>
                                            )
                                        }

                                        {
                                            !kind.startsWith("労務費") &&
                                            (
                                                <div className="col-2">
                                                    <Field
                                                        name={`${name}[${parentIndex}].data[${index}].budget`}
                                                        component={FormText}
                                                        label="予算"
                                                        style={{ width: '100%' }}
                                                        format={commons.dispMoney}
                                                        normalize={commons.dispMoney}
                                                        disabled={status === 3 || kind.startsWith('労務費')}
                                                        meta={{touched: true, error: error.budget}}
                                                    />
                                                </div>
                                            )
                                        }

                                    </div>

                                    <div className="row">
                                        <div className="col">
                                            <Field name={`${name}[${parentIndex}].data[${index}].comment`}
                                                   component={FormText} label="備考" style={{ width: '100%' }}
                                                   disabled={status === 3 || kind.startsWith('労務費')} />
                                        </div>
                                    </div>

                                </div>

                                <div className="col-1">
                                    <div style={{ display: 'flex', flexDirection: 'column',justifyContent: 'center', alignItems: 'center', height: '100%', paddingTop: '5px' }}>
                                        <FloatingActionButton zDepth={0}
                                                              mini={true}
                                                              backgroundColor={colors.red300}
                                                              onClick={() => {
                                                                  const newCosts = costs.filter((x, i) => index != i);
                                                                  dispatch(change('yosanForm', `${name}[${parentIndex}].data`, newCosts))
                                                              }}
                                                              disabled={
                                                                  kind.startsWith('労務費')
                                                                  || (row.importDate)
                                                                  || (resultDisable && row.result)
                                                                      ? true : false}
                                        >
                                            <ContentRemove />
                                        </FloatingActionButton>
                                    </div>

                                </div>

                            </div>
                        )
                    })
                }
                <div className="row">
                    <div className="col" style={{textAlign: 'center', marginTop: 10}}>
                        {
                            costs.length > this.state.marker
                                ? <FlatButton label={`もっと見る`} onClick={this.loadList.bind(this)}/>
                                : ''
                        }
                    </div>
                </div>
                {/*<Loading open={this.state.loading}/>*/}
            </div>
        )
    }
}


export default CostMonthCardContents



// WEBPACK FOOTER //
// ./src/components/CostMonthCardContents.js